module.exports = __webpack_public_path__ + "static/media/integrative.804a7f4a.png";